/* quote-feedback.js
   UI glue for quote-cart.js — shows fading popup, reads qty, calls quoteCart.addItem
   Requires: quote-cart.js to be loaded earlier (window.quoteCart)
*/
(function () {
  if (!window || !document) return;

  // Translation map (extend if needed)
  const TEXT = {
    es: {
      added_to_quote: 'Se ha agregado su(s) producto(s) al carrito',
      added_short: 'Agregado'
    },
    en: {
      added_to_quote: 'Your product(s) have been added to the cart',
      added_short: 'Added'
    }
  };

  // Language detection: prefer <html lang="...">, fallback to 'es'
  const docLang = (document.documentElement && document.documentElement.lang) || '';
  const lang = docLang.indexOf('en') === 0 ? 'en' : 'es';

  // Create popup element (if not present)
  function createPopup() {
    let popup = document.getElementById('quote-feedback-popup');
    if (popup) return popup;

    popup = document.createElement('div');
    popup.id = 'quote-feedback-popup';
    popup.className = 'quote-feedback-popup hidden';
    popup.setAttribute('role', 'status');
    popup.setAttribute('aria-live', 'polite');

    const inner = document.createElement('div');
    inner.className = 'quote-feedback-inner';
    popup.appendChild(inner);

    document.body.appendChild(popup);
    return popup;
  }

  // Show message, auto fade
  function showPopup(message, duration = 2000) {
    const popup = createPopup();
    const inner = popup.querySelector('.quote-feedback-inner');
    inner.textContent = message;

    // Show
    popup.classList.remove('hidden');
    popup.style.opacity = '0';
    popup.style.display = 'block';
    popup.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, fill: 'forwards' });

    // Hide after duration
    setTimeout(() => {
      popup.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: 'forwards' });
      setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.add('hidden');
      }, 300);
    }, duration);
  }

  // Safely read quantity from card: looks for common inputs inside the same card wrapper
  function readQuantity(cardElement) {
    if (!cardElement) return 1;
    const selectors = [
      '.quantity__input', // Dawn native
      'input[name="quantity"]',
      'input.item_qty', // custom quoting UI
      '.grfq-item-quantity-input'
    ];
    let val = 1;
    for (const sel of selectors) {
      const input = cardElement.querySelector(sel);
      if (input && input.value !== undefined) {
        const parsed = parseInt(input.value, 10);
        if (!isNaN(parsed) && parsed > 0) {
          val = parsed;
          break;
        }
      }
    }
    return val;
  }

  // Event handler: delegated to document
  document.addEventListener('click', function (ev) {
    const btn = ev.target.closest('.product__add-to-quote');
    if (!btn) return;

    ev.preventDefault();

    if (btn.disabled) return;

    // Read data attributes
    const productId = btn.dataset.productId || '';
    const variantId = btn.dataset.variantId || '';
    const title = btn.dataset.productTitle || '';

    // Find plausible card wrapper to read the qty (walk up to nearest card-wrapper or li.grid__item)
    const cardEl = btn.closest('.card-wrapper, .card, li.grid__item, .product-card-wrapper') || document;
    const qty = readQuantity(cardEl);

    // Add to quote cart via window.quoteCart (must exist)
    if (window.quoteCart && typeof window.quoteCart.addItem === 'function') {
      window.quoteCart.addItem(productId, variantId || ('v-' + Math.random().toString(36).slice(2, 8)), title, qty);

      // publish a custom event so other scripts can react
      try {
        window.dispatchEvent(new CustomEvent('quote:updated', { detail: { items: window.quoteCart.items } }));
      } catch (e) {}
    } else {
      // If quoteCart missing, log gracefully
      console.warn('quoteCart not initialized — make sure quote-cart.js is loaded before quote-feedback.js');
    }

    // UI feedback
    const addedMsg = TEXT[lang].added_to_quote || TEXT.es.added_to_quote;
    showPopup(addedMsg, 2000);

    // Temporarily change button text and disable
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = TEXT[lang].added_short || 'Added';

    // return button to normal after popup
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2600);

    // Redirect rule: if on product page, after popup redirect to home; otherwise, stay.
    // (You can replace '/' with the preferred landing page)
    if (window.location.pathname.indexOf('/products/') === 0) {
      setTimeout(() => {
        window.location.href = '/';
      }, 2600);
    }
  });

  // ensure popup DOM exists early
  createPopup();

})();
